import { useState } from 'react';
import logo from '../assets/logo.png';
import { motion } from 'framer-motion';

const Navbar = () => {
    const [ isOpen, setIsOpen ] = useState(false)

    const handleToggle = () => {
        setIsOpen(!isOpen)
    }

    const ul = [
        {
            id: '#',
            name: 'Home'
        },
        {
            id: '#about',
            name: 'About us'
        },
        {
            id: '#services',
            name: 'Service'
        },
        {
            id: '#project',
            name: 'Our Project'
        }
    ]

    return (
        <motion.div 
            className="fixed w-full bg-darkBlue flex justify-between items-center px-8 tab:px-4 py-6 text-greys z-30"
            variants={{
                hidden: { opacity: 0, y: -75 },
                visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5 }}
            initial="hidden"
            animate="visible"
        >

            <img 
                src={logo} 
                alt="Logo" 
                className='w-28'
            />

            <ul className={`ul-slideIn animi tab:z-30 ${
                isOpen ? 'left-0' : 'left-full'
            }`}>
                {
                   ul.map(item => (
                        <a href={item.id} key={item.id}>
                             <li
                                className="text-[17px] cursor-pointer animi ease-in-out hover:text-blue"
                                onClick={handleToggle}
                            >
                                {item.name}
                            </li>
                        </a>
                    ))
                }
            </ul>

            <button 
                className="contact animi tab:hidden"
            >
                Contact us
            </button>

            <div 
                className={`animi hidden tab:block absolute right-3 bg-transparent w-15 h-15 p-2 z-40 ${
                    isOpen ? 'rotate-[360deg]' : 'rotate-0' 
                }`}
                onClick={handleToggle}
            >
                <span className={`animi block w-4 h-[2px] rounded-md absolute right-0 ${
                    isOpen ? 'bg-transparent' : 'bg-white'
                }`}>
                <span className={`animi absolute -top-[6px] bg-white w-5 h-[2px] rounded-md right-0 ${
                    isOpen ? 'rotate-45 top-1.5' : 'rotate-0'
                }`}></span>
                <span className={`animi absolute top-[6px] bg-white w-3 h-[2px] rounded-md right-0 ${
                    isOpen ? '-rotate-45 w-5 top-0' : 'rotate-0'
                }`}></span>
                </span>
            </div>
        </motion.div>
  );
};

export default Navbar;
